export default __webpack_public_path__ + "static/media/home.2f850fbe.svg";